<template>
  <main class="account-page">
    <LanguageChoice />

    <div class="container">
      <div class="form">
        <form action="#"
              class="logout-form"
              @submit.prevent="handleLogoutSubmit"
        >
          <MainButton :button-text="$t(`accountPage.logout`)"
                      type="submit"
                      style="height:50px;margin-bottom:1rem;"
          />
        </form>
      </div>
    </div>
  </main>
</template>

<script setup>
import LanguageChoice from '../components/subcomponents/LanguageChoice.vue'
import { useStore } from 'vuex'
import MainButton from '@/components/buttons/MainButton.vue'

const store = useStore()

function handleLogoutSubmit () {
  localStorage.clear('token')
  store.commit('sidebar/sidebarLogOut')
  window.location.href = '/login'
}

</script>

<style lang="scss" scoped>

.account-page {
  height: 100%;
  overflow-y: auto;
  background: linear-gradient(90deg, var(--gray) 0%, var(--background2) 10px);
}
.iconButton {
  position: absolute;
  top: 0;
  padding: 1px;
  right: 60px;
  z-index: 2;
  border: none;
  top: 40px;
  height: 30px;
  cursor: pointer;

  transform: translateX(4px);
}
.clearButton {
  position: absolute;
  top: 0;
  padding: 1px;
  right: 30px;
  z-index: 2;
  border: none;
  top: 40px;
  height: 30px;
  cursor: pointer;
  transform: translateX(2px);
}
.clearButtonRepPass {
  position: absolute;
  top: 0;
  padding: 1px;
  right: 30px;
  z-index: 2;
  border: none;
  top: 40px;
  height: 30px;
  cursor: pointer;
  transform: translateX(2px);
}
.container {
  padding: 8% 0 0;
  width: 365px;
  margin: auto;
}

.passwordDiv {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  vertical-align: middle;

  .singleColumn {
    display: flex;
    flex-direction: column;
    margin-right: 1rem;
  }
}

.form {
  position: relative;
  z-index: 1;
  max-width: 350px;
  margin: 0 auto 25px;
  padding: 30px;
  background: var(--mainBlue);
  border-radius: 20px;
}

.form {
}

.form .register-form {
  display: none;
}

@media (max-width: 768px) {
.account-page {
  height: 100%;
}
  .container {
    padding: 8% 0 0;
    width: 275px;
    margin: auto;
  }
  .clearButton {
    top: 44px;
    right: 2px;
  }
  .clearButtonRepPass {
    top: 110px;
    right: 2px;
  }
  .iconButton {
    top: 44px;
    right: 35px;
  }

  .form {
    position: relative;
    z-index: 1;
    max-width: 270px;
  margin: 0 auto 25px;
    padding: 25px;
    border-radius: 20px;
  }
}
</style>
